<template>
  <div>
    <score-list></score-list>
    <detail-page></detail-page>
  </div>
</template>

<script>
import detailPage from './components/detailPage.vue'
import scoreList from './components/scoreList.vue'
export default {
  name: 'App',
  components: {
    detailPage,
    scoreList
  }
}
</script>

<style>
#jifenDetail {
  margin: 0;
  padding: 0;
  border: 0;
}
p{
  margin: 0;
  padding: 0;
}
.scoreList{

}
.detailPage{
  display: none;
}
</style>
